//
import lodash from "lodash";
//component
//redux
//selector
import { isLoggedSelector } from "store/user/auth/user_auth.selector";
import { permissionsSelector } from "store/bailiff/auth/base_auth.selector";
//actions
//utils
import { newItems, newMenus } from "screen/00_Nav/url";
//hook
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
//str

export const useMenuClone = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [items, setItems] = useState({});
  const [menu, setMenu] = useState([]);
  // -------------------------- REDUX ---------------------------
  const logged = useSelector(isLoggedSelector);
  const claim = useSelector(permissionsSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (!claim) {
      return;
    }
    const permissions = claim ? JSON.parse(claim)?.operators : [];
    const items = newItems();
    const byPermissions = filterPermissions(items, permissions);
    const menu = newMenus(byPermissions);
    // const authMenu = newAuthMenu(byPermissions, logged);
    // const dashboard = newDashboard(byPermissions);
    setItems(byPermissions);
    setMenu(menu);
    // setAuthMenu(authMenu);
    // setDashboard(dashboard);
  }, [logged, claim]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { items, menu };
};

const filterPermissions = (items, permissions) => {
  const list = Object.entries(items)
    .map((item) => {
      const key = item[0];
      const value = item[1];
      const require = value?.require;
      const diff =
        require?.length > 0 ? lodash.difference(require, permissions) : [];
      const valid = diff?.length === 0 ? true : false;
      return { key, value, valid };
    })
    .filter((item) => item?.value)
    .reduce((obj, item) => Object.assign(obj, { [item.key]: item.value }), {});
  return list;
};
